/**
 * What to tell the user when an extraction FAILED: one short, general message, the
 * same for every failure. The recorded technical reason (memory, timeouts, page
 * caps, crashes) is for operators only — it shows on the admin Extraction Runs tab
 * and never reaches the user. Kept as a function so every screen and tooltip reads
 * the one definition.
 */

export interface FailedExtractionCopy {
  title: string;
  body: string;
}

export const FAILED_EXTRACTION_TITLE = 'We couldn’t read this document';
export const FAILED_EXTRACTION_BODY = 'Please try uploading it again.';

export function failedExtractionCopy(_reason?: string | null): FailedExtractionCopy {
  return { title: FAILED_EXTRACTION_TITLE, body: FAILED_EXTRACTION_BODY };
}
